import PropTypes from 'prop-types';
import React from 'react';

import {
  Header, Sidebar, NavigationDrawer, DorDrawer,
} from './components';

export const OverlayWrapper = ({
  levels,
  showStickyNav,
  isPageModal = false,
  isLandingPage = false,
  isHideHeader = false,
  hasModalChildren = false,
}) => (
  <>
    {(!isHideHeader) && (
      <Header
        levels={levels}
        showStickyNav={showStickyNav}
        isPageModal={isPageModal}
        isLandingPage={isLandingPage}
        hasModalChildren={hasModalChildren}
      />
    )}
    {(!isLandingPage) && <Sidebar />}
    {(!isLandingPage) && <NavigationDrawer />}
    {(!isLandingPage) && <DorDrawer />}
  </>
);

OverlayWrapper.propTypes = {
  levels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  showStickyNav: PropTypes.bool.isRequired,
  isPageModal: PropTypes.bool.isRequired,
  isLandingPage: PropTypes.bool.isRequired,
  isHideHeader: PropTypes.bool.isRequired,
};
